import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { legalPublicClient, type LegalType, LEGAL_TYPE_LABELS } from '../../services/adminClient'

const TIPO_MAP: Record<string, LegalType> = {
  tos: 'TOS',
  pp: 'PP',
}

export function LegalPublicPage() {
  const { tipo } = useParams<{ tipo: string }>()
  const legalType = TIPO_MAP[tipo ?? '']

  const [html, setHtml] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!legalType) {
      setLoading(false)
      setError('Documento no encontrado.')
      return
    }
    setLoading(true)
    legalPublicClient
      .current(legalType)
      .then((res) => setHtml(res.document.content_html))
      .catch(() => setError('No se pudo cargar el documento. Intenta más tarde.'))
      .finally(() => setLoading(false))
  }, [legalType])

  const title = legalType ? LEGAL_TYPE_LABELS[legalType] : 'Documento legal'

  return (
    <main style={{ maxWidth: '780px', margin: '0 auto', padding: '2rem 1.5rem' }}>
      <Link to="/register/complete" style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>
        ← Volver al registro
      </Link>
      <h1 style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>{title}</h1>
      {loading && <p className="muted">Cargando…</p>}
      {error && <p style={{ color: 'var(--color-error, red)' }}>{error}</p>}
      {!loading && !error && (
        <div
          className="legal-content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </main>
  )
}
